import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiTableCell-root': {
      backgroundColor: `#FFFFFF !important`,
    },

    '& .MuiTableCell-body': {
      paddingLeft: '1rem !important',
    },
  },

  rowTableIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: theme.palette.primary.main,
  },

  tableIcon: {
    fontSize: 20,
    color: theme.palette.primary.main,
    marginTop: '3px',
    marginLeft: '7px',
  },

  group: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '0.5rem 0',
  },

  groupText: {
    marginLeft: '10px',
    margin: 0,
    padding: 0,
    fontFamily: 'Nunito !important',
    fontSize: '14px !important',
    lineHeight: '20px !important',
    fontWeight: '400 !important',
    maxWidth: '300px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  text: {
    minWidth: '100px',
    maxWidth: '120px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  subTitle: {
    opacity: 0.5,
    fontSize: '13px !important',
  },

  chip: (props: any) => ({
    backgroundColor: `${props.color == null && 'rgba(25,28,26, 0.08)'}  !important`,
    border: `1px solid ${props.color} !important`,
    color: `${props.color} !important`,
    borderRadius: '1rem',
    padding: '0rem 0.75rem',
    marginLeft: '0rem !important',
  }),

  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
  },
}))

export { useStyles }
